<template>
  <div class="app">
    <main-bar v-if="!$route.meta.skipAuth"/>
    <div class="app-content">
      <router-view :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
import { Component, BaseComponent } from '@/libs/BaseComponent'
import Header from '@/modules/header/_views/Header'

@Component({
  components: {
    'main-bar': Header
  }
})
export default class App extends BaseComponent {

  // TODO créer un component offline pour le signin signup etc ... avec un v-if sur le skipAuth

}
</script>

<style lang="scss">
  *, *:before, *:after { box-sizing: border-box;transition:0.25s; }
  body {
    padding: 0;
    margin: 0;
    background: #393d40;
  }
  input {
    outline: none;
  }
  .app {
    width: 100vw;
    height: 100vh;
    background: #393d40;
    font-family: montserrat;
    position: relative;

    .app-content {
      height: calc(100vh - 64px);
    }

    .elicut {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    .el-dialog {
      background: none;
      border-radius: 8px;
      box-shadow: 0px 0px 1px #ccc;

      .el-dialog__header {
        background: #191d20;
        color: #fff;
        border-radius: 8px 8px 0 0;

        .el-dialog__title {
          color: white;
        }
      }
      .el-dialog__body {
        background: #474c52;
        color: white;
      }
      .el-dialog__footer {
        background: #474c52;
        border-top:0.5px solid #404040;
        color: white;
        border-radius: 0 0 8px 8px;
        padding: 12px 12px 12px;
      }
    }
    .d-btn {
      background: #fdd318;
      border-color: #fdd318;
    }
    .input-c {
      padding: 12px;
      font-size: 14px;
      border-radius: 8px;
      border: 1px solid #6a6d72;
      background: #272b2e;
      color: rgba(255,255,255,0.6);
      transition: 0.25s;

        &:active, &:focus {
          color: #ccc;
          border: 1px solid #9a9da2;
        }
    }
    .btn-c {
      cursor: pointer;

      &:hover {
        filter: brightness(114%);
      }
      &:active {
        filter: brightness(80%);
        transform: translateY(2px);
      }
    }
  }
  .el-message {

      &.el-message--success {
        background: #191d20;
        border: none;

        .el-message__content {
          color: #e1f3d8;
        }
      }
    }
  .el-picker-panel {
      background: #191d20;
      color: #c0c4cc;

      .el-date-picker__time-header {
        .el-input__inner {
          background: #272b2e;
          color: #eee;
          border: 0.5px solid #6a6d72;
        }
      }
      .el-picker-panel__icon-btn {
        color: #fdd318;
      }
      .el-date-table td.available:hover {
        color: #fdd318;
      }
      .el-date-table td.today span {
        color: #fdd318;
      }
      .el-date-table td.next-month, .el-date-table td.prev-month {
        color: #606266;
      }
      .el-date-table td.current:not(.disabled) span {
        background: #6a6d72;
      }

      .el-picker-panel__footer {
        background: #191d20;

        .el-button--text {
          color:#fff;
        }

        .el-button--default {
          background: #fdd318;
          color: #fff;
          border-color: #fdd318;
        }
      }
    }
    .el-cascader-menus {
      background: #171717;
      border: none;
      .el-cascader-menu {
        background: #171717;
        border-color: #272727;
      }
    }
    .el-cascader .el-input.is-focus .el-input__inner {
      border-color: rgba(200, 30, 30);
    }
    .el-cascader-menu__item.is-active {
      color: rgba(200, 30, 30);
    }

    .el-table, .el-table__expanded-cell{
      background: #393d40;
      color: #efefef;
    }
     .el-table th, .el-table tr {
      background: #393d40;
      color: #efefef;

      &:hover {
        background: #393d40;
        color: #efefef;
      }
    }
    .el-table__row .hover-row {
      background:  #222;
    }
    .el-table__body tr.hover-row>td {
      background: #393d40;
    }
    .el-table--border::after, .el-table--group::after, .el-table::before {
      background: #393d40;
    }
    .el-table__row .el-table__row--striped, .el-table--striped .el-table__body tr.el-table__row--striped td {
      background: #606060;
    }
    .el-table__fixed-right::before, .el-table__fixed::before {
      height: 0px;
    }
    .el-button--text {
      color: #fdd318;
    }
    .el-button--text:focus, .el-button--text:hover {
      color: #fdd318;
    }
    .el-cascader-menu__item, .el-cascader__label {
      color: #ccc;
    }
    .el-cascader-menu__item:focus:not(:active), .el-cascader-menu__item:hover {
      background: #551111;
    }
</style>
